/* eslint-disable class-methods-use-this */
import Resource from '@/services/resources/common';

export default class DashboardLayoutTypeResource extends Resource {
  constructor(entrypoint = '/dashboard_layout_types', alias = 'DashboardLayoutType') {
    super(entrypoint, alias);
  }
}
